// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"BraceTooltip_tooltip__2Bg5X","popoverContainer":"BraceTooltip_popoverContainer__2ODQo","portal":"BraceTooltip_portal__2YZmu"};